// extracted by mini-css-extract-plugin
module.exports = {"fields":"AbsenceModal_fields__16sc9","footer":"AbsenceModal_footer__2a8lO"};